module.exports = __webpack_public_path__ + "img/welfarecell1.413162ef.png";